import React from "react";

const OptionIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="24" height="24" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0" transform="scale(0.0416667)" />
        </pattern>
        <image
          id="image0"
          width="24"
          height="24"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAKElEQVQ4y2NgGKbgv8f/x0DoQbyGR/9B4BENNZDqpNFQGhxgNJToDgDiB1Rh9jp8GgAAAABJRU5ErkJggg==="
        />
      </defs>
    </svg>
  );
};

export default OptionIcon;
